export const returnError = (newError) => {
  // console.log('error print here', newError.response.data);
  const errorMsg = newError?.response?.data.error
    ? newError?.response?.data.error
    : newError?.response?.data;
  return errorMsg;
};

export const returnConfig = () => {
  return {
    headers: {
      'Content-Type': 'application/json',
    },
  };
};

// Setup config/headers and token
export const tokenConfig = (getState) => {
  const urlParams = window.location.pathname;
  const adminUser = urlParams.includes('admin');
  // console.log('adminUser', adminUser);
  const token = adminUser
    ? localStorage.getItem('centralize-admin-token')
    : localStorage.getItem('centralize-dev-user-token');

  // console.log('token after log out and log in', token);
  // Headers
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  //if there is a token then add it to the header
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
};
